setTimeout(() => {
  const waitForSwiper = setInterval(() => {
    const el = document.querySelector('.product__media-container.below-mobile.carousel');
    if (el && el.swiper) {
      clearInterval(waitForSwiper);
      el.swiper.on('slideChangeTransitionEnd', () => {
        document.querySelectorAll('.plyr__control').forEach(btn => {
          btn.classList.add('show-btn');
        });
      });
      document.addEventListener('click', function (e) {
        console.log(e);
        if (e.target.classList.contains('plyr__control')) {
          e.target.classList.remove('show-btn');
        }
      });
      document.querySelectorAll('.plyr__control').forEach(btn => {
        btn.classList.add('show-btn');
      });
    }
  }, 300);
}, 1500);


// PDP Desc Read more Logic
document.addEventListener("DOMContentLoaded", function () {
  const mql = window.matchMedia("(max-width: 767px)");

  function setupMobileToggle() {
    if (mql.matches) {
      const readMore = document.getElementById("read-more");
      const readLess = document.getElementById("read-less");
      const truncated = document.getElementById("truncated-description");
      const fullMobile = document.getElementById("full-description-mobile");

      if (readMore && fullMobile) {
        readMore.onclick = () => {
          truncated.style.display = "none";
          fullMobile.style.display = "block";
        };
        readLess.onclick = () => {
          fullMobile.style.display = "none";
          truncated.style.display = "block";
        };
      }
    }
  }

  setupMobileToggle();
  
  mql.addEventListener("change", setupMobileToggle);
});
